jQuery(function() {
    if ($('.teeth-page').length > 0) {

        /**
         * Get products by manucturer
         */
        $('.teeth-page').on('change', '.manufacturer', function() {
            var productsElement = $('.teeth-page').find('select.products');
            productsElement.selectpicker('destroy');
            if ($(this).val() == '') {
                productsElement.addClass('d-none');
            } else {
                $.ajax({
                    url: $('link[rel="avency-nwd-products-tooth-products"]').attr('href'),
                    data: {
                        'manufacturer': $(this).val()
                    }
                }).done(function (data) {
                    var options = '';
                    const currentUri =new URL(location.href);

                    for (var i = 0; i < data.length; i++) {
                        const uri = data[i].uri;
                        const selected = uri === currentUri.pathname;

                        options += '<option value="' + uri + '" ' + (selected ? 'selected ' : '') + '>' + data[i].title + '</option>';
                    }

                    productsElement.html(options);
                    productsElement.removeClass('d-none');
                    productsElement.selectpicker();
                });
            }
        });

        var manufacturerSelect = $('.teeth-page .manufacturer');
        if (manufacturerSelect.data('selected') !== '') {
            manufacturerSelect.trigger('change');
        }

        $(document).ready(function () {
            $('.teeth-content table').DataTable({
                scrollY: 400,
                scrollX: true,
                paging: false,
                searching: false,
                ordering: false,
                info: false,
                fixedColumns: true,
                fixedHeader: {
                    header: true,
                },
                layout: {
                    topStart: null,
                    topEnd: null,
                    bottomStart: null,
                    bottomEnd: null
                },
            });
        });

        /**
         * Get products by manufacturer
         */
        $('.teeth-page').on('change', '.products', function() {
            var loading = $('.teeth-page .loading').html();

            $('.teeth-page .teeth-content').html(loading);
            window.location.href = $(this).val();
            return false;
        });

        /**
         * Activate cells on mouseover
         */
        $('.teeth-page').on('mouseenter', '.teeth-content td', function(e) {
            /** @var {HTMLTableCellElement} target */
            const element = $(this).get(0);
            var currentCellIndex = element.cellIndex;
            $('.teeth-content').find('th, td').each(function() {
                if (element.cellIndex === currentCellIndex) {
                    $(element).addClass('active');
                }
            });
            if (!$(element).hasClass('warning') && !$(element).hasClass('danger')) {
                $(element).addClass('success');
            }
            $(element).parent('tr').addClass('active');
            var rowIndex = $(element).parent('tr').index('.teeth-content tbody tr');
            $('.DTFC_Cloned tbody tr').eq(rowIndex).addClass('active');
        });

        $('.teeth-page').on('mouseleave', '.teeth-content td', function() {
            $('.teeth-content').find('tr, th, td').removeClass('active').removeClass('success');
        });
    }
});
